<script setup lang="ts">
import { Order, PaginationData, Statuses } from '@/@types/order'

import Pagination from '@/components/shared/base_orders/Pagination.vue'
import Table from '@/components/shared/base_orders/Table.vue'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardFooter, CardHeader } from '@/components/ui/card'

import { Link } from '@inertiajs/vue3'
import FormFilter from './FormFilter.vue'

withDefaults(
    defineProps<{
        orders: Order[]
        workshopId: number
        statuses: Statuses
        pagination: PaginationData
        id?: number
        status?: string
        isAdmin?: boolean
    }>(),
    {
        isAdmin: false,
    },
)
</script>

<template>
    <Card class="min-h-96">
        <CardHeader>
            <FormFilter :statuses="statuses" :workshopId="workshopId" />
        </CardHeader>
        <CardContent>
            <Table :orders="orders" :has-sort="true" v-if="orders.length" :isAdmin="isAdmin" />

            <div v-else>
                <div class="flex flex-col items-center gap-6">
                    <p>{{ $t('No orders were found with the applied filters') }}.</p>
                    <Button :as="Link" variant="secondary" href="/admin/orders?workshop_id=1" :only="['orders', 'order_by_status']" preserve-scroll>
                        {{ $t('Clear filters') }}
                    </Button>
                </div>
            </div>
        </CardContent>
        <CardFooter v-if="pagination.per_page < pagination.total">
            <Pagination :pagination="pagination" />
        </CardFooter>
    </Card>
</template>
